module.exports = __webpack_public_path__ + "static/media/proj19_img5.dea036a5.jpg";